export const colors = {
  yellow: "Gelb",
  orange: "Orange",
  red: "Rot",
  purple: "Lila",
  blue: "Hellblau",
  green: "Grün",
};
